import PropTypes from 'prop-types';
import React from 'react';

import { Color } from '../../../shared/constants/Colors';
import * as S from './Card.styles';

export const CardAppearance = {
  VERTICAL: 'vertical',
  SIMPLE: 'simple',
  HORIZONTAL: 'horizontal',
};

export const Card = ({
  appearance,
  children,
  isFloating,
  gradientColor1,
  gradientColor2,
  isStatic,
}) => {
  const gradientColor =
    gradientColor1 && gradientColor2
      ? `linear-gradient(156.91deg, ${gradientColor1} 0%, ${gradientColor1} 0.06%, ${gradientColor2} 100%)`
      : 'none';
  const defaultBackground =
    !isFloating && !gradientColor1 && !gradientColor2 ? Color.WHITE : 'default';

  return (
    <S.StyledCard
      appearance={appearance}
      defaultBackground={defaultBackground}
      gradientColor={gradientColor}
      isFloating={isFloating}
      isStatic={isStatic}
    >
      {children}
    </S.StyledCard>
  );
};

Card.propTypes = {
  /**
   * Set the appareance of the card.
   */
  appearance: PropTypes.oneOf(Object.values(CardAppearance)),
  /**
   * The displayed content of the card.
   */
  children: PropTypes.node,
  /**
   * Set the first color to display a gradient as the card background.
   * Needs appearance to be set on Simple.
   */
  gradientColor1: PropTypes.oneOf(Object.values(Color)),
  /**
   * Set the second color to display a gradient as the card background.
   * Needs appearance to be set on Simple.
   */
  gradientColor2: PropTypes.oneOf(Object.values(Color)),
  /**
   * Displays a box-shadow.
   * The card cannot have a gradient background if true.
   */
  isFloating: PropTypes.bool,
  /**
   * Has no hover style if true.
   * Has effect only if appearance === simple.
   */
  isStatic: PropTypes.bool,
};

Card.defaultProps = {
  appearance: CardAppearance.SIMPLE,
  gradientColor1: Color.CLOUD_BURST,
  gradientColor2: Color.BLUE_CHATHAMS,
  isFloating: false,
  isStatic: false,
};
